import Reveal from '@/components/base/Reveal';
import { strategyReport } from '@/utils/strategyReport';
import FigureStrip from '@/pages/home/components/performance/FigureStrip';
import GaugeBar from '@/pages/home/components/performance/GaugeBar';
import SummaryRing from '@/pages/home/components/performance/SummaryRing';

function AccountPerformance() {
  return (
    <section id="performance" className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[34px] leading-[1.08] sm:text-[44px] lg:text-[50px]">
            The Strategy Report, Trade By Trade
          </h2>
          <p className="mt-4 text-[14px] md:text-[15px] text-foreground-600 max-w-[620px] leading-relaxed">
            A full MetaTrader-style summary of the recorded account. Every figure below is derived
            from the same trade ledger, so nothing here can drift out of sync.
          </p>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-10 rounded-lg border border-background-300 bg-background-100">
            <div className="overflow-hidden rounded-t-lg">
              <FigureStrip />
            </div>

            <div className="px-5 py-7 md:px-8 md:py-9">
              <h3 className="font-heading text-[16px] font-bold text-foreground-950 md:text-[18px]">
                1. Summary
              </h3>

              <div className="mt-7 grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)_minmax(0,1fr)]">
                <SummaryRing />

                <div className="flex flex-col gap-7 lg:border-l lg:border-background-200 lg:pl-8">
                  <GaugeBar
                    label="Sharpe Ratio"
                    display={strategyReport.sharpeRatioText}
                    value={strategyReport.sharpeRatio}
                    min={0}
                    max={5}
                    minLabel="0"
                    maxLabel="5"
                  />
                  <GaugeBar
                    label="Profit Factor"
                    display={strategyReport.profitFactorText}
                    value={strategyReport.profitFactor}
                    min={0}
                    max={4}
                    minLabel="0"
                    maxLabel="4"
                    detail={strategyReport.profitFactorDetail}
                  />
                  <GaugeBar
                    label="Recovery Factor"
                    display={strategyReport.recoveryFactorText}
                    value={strategyReport.recoveryFactor}
                    min={0}
                    max={7}
                    minLabel="0"
                    maxLabel="7"
                  />
                </div>

                <div className="flex flex-col gap-7 lg:border-l lg:border-background-200 lg:pl-8">
                  <GaugeBar
                    label="Max. Drawdown"
                    display={strategyReport.maxDrawdownText}
                    value={strategyReport.maxDrawdownPercent}
                    min={0}
                    max={100}
                    minLabel="0%"
                    maxLabel="100%"
                    detail={strategyReport.drawdownDetail}
                    align="right"
                  />
                  <GaugeBar
                    label="Max. Deposit Load"
                    display={strategyReport.maxDepositLoadText}
                    value={strategyReport.maxDepositLoad}
                    min={0}
                    max={100}
                    minLabel="0%"
                    maxLabel="100%"
                  />
                  <GaugeBar
                    label="Trades per Week"
                    display={strategyReport.tradesPerWeekText}
                    value={strategyReport.tradesPerWeek}
                    min={0}
                    max={10}
                    minLabel="0"
                    maxLabel="10"
                  />
                  <GaugeBar
                    label="Average Hold Time"
                    display={strategyReport.avgHoldText}
                    value={strategyReport.avgHoldHours}
                    min={0}
                    max={24}
                    minLabel="0"
                    maxLabel="1d"
                  />
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default AccountPerformance;